import { createSlice } from '@reduxjs/toolkit';

export const FEATURE_SLICE_NAME = 'assetTree';

export type AssetTreeSelectionChangeEvent = {
    accountIds: string[];
    assetIds: string[];
    workshopIds: string[];
};

export type AssetTreeState = AssetTreeSelectionChangeEvent & {
    initialized: boolean;
};

const initialState: AssetTreeState = {
    workshopIds: [],
    accountIds: [],
    assetIds: [],
    initialized: !document.referrer,
};

const assetTreeSlice = createSlice({
    name: FEATURE_SLICE_NAME,
    initialState,
    reducers: {
        assetTreeSelectionChanged: (state, action: { payload: AssetTreeSelectionChangeEvent }) => {
            const { workshopIds, accountIds, assetIds } = action.payload;
            const asString = (arr: string[]) => JSON.stringify(arr.slice().sort());

            if (
                state.initialized &&
                asString(state.workshopIds) === asString(workshopIds) &&
                asString(state.accountIds) === asString(accountIds) &&
                asString(state.assetIds) === asString(assetIds)
            ) {
                return;
            }

            state.workshopIds = workshopIds || [];
            state.accountIds = accountIds || [];
            state.assetIds = assetIds || [];
            state.initialized = true;
        },
    },
});

export const { assetTreeSelectionChanged } = assetTreeSlice.actions;
export default assetTreeSlice.reducer;

export const getAssetTreeSelection = (state: { [FEATURE_SLICE_NAME]: AssetTreeState }): AssetTreeState =>
    state[FEATURE_SLICE_NAME];
